import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  background: var(--glass-1);
  padding: 30px;
  border-radius: 16px;
  border: 1px solid var(--glass-border);
  backdrop-filter: blur(10px);
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  
  h3 { margin: 0; color: var(--text-primary); font-size: 20px; }
  .controls { display: flex; gap: 10px; }
  .btn { width: 36px; height: 36px; border-radius: 50%; background: var(--glass-2); border: 1px solid var(--glass-border); display: flex; align-items: center; justify-content: center; color: var(--text-primary); cursor: pointer; }
  .btn:hover { background: var(--accent); color: #fff; border-color: var(--accent); }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
`;

const Item = styled.div`
  background: rgba(0,0,0,0.2);
  border: 1px solid var(--glass-border);
  border-radius: 12px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    border-color: var(--accent);
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(6,182,212,0.15);
  }
`;

const ImgHolder = styled.div`
  height: 120px;
  background: var(--glass-2);
  border-radius: 8px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: var(--text-muted);
  img { max-height: 100%; max-width: 100%; object-fit: contain; }
`;

const CrossSellWidget = ({ node }) => {
  const items = [
    { title: 'Apple AirPods Pro', price: '279,00 €', img: 'https://via.placeholder.com/150/1e293b/00A9E0?text=AirPods' },
    { title: 'MagSafe Charger', price: '49,00 €', img: 'https://via.placeholder.com/150/1e293b/00A9E0?text=Charger' },
    { title: 'Silicone Case O2 Edition', price: '29,00 €', img: 'https://via.placeholder.com/150/1e293b/00A9E0?text=Case' },
  ];

  return (
    <Wrapper width={node.style?.desktop?.width}>
      <Header>
        <h3>{node.content?.title || 'Das könnte dir auch gefallen'}</h3>
        <div className="controls">
          <div className="btn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16"><path d="M15 18l-6-6 6-6"></path></svg></div>
          <div className="btn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16"><path d="M9 18l6-6-6-6"></path></svg></div>
        </div>
      </Header>
      <Grid>
        {items.map((it, i) => (
          <Item key={i}>
            <ImgHolder><img src={it.img} alt={it.title} /></ImgHolder>
            <div style={{fontWeight:600, color:'var(--text-primary)', fontSize:14, marginBottom:6}}>{it.title}</div>
            <div style={{color:'var(--accent)', fontWeight:800, fontSize:16}}>{it.price}</div>
          </Item>
        ))}
      </Grid>
    </Wrapper>
  );
};

registry.register('cross_sell', {
  label: 'Cross Sell Slider',
  icon: '🛒',
  category: 'tef_specific',
  defaultContent: {},
  defaultStyle: { desktop: { width: '100%' } },
  render: CrossSellWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Text', fields: [{name:'content.title', label:'Titel', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.width', label:'Breite', type:'text'}] }] }
  ]
});
